import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import useSearchQuery from '@/hooks/useSearchQuery';
import PropertyContent from '../../../../propTypes/PropertyContent';
import PropertiesContentContext from './PropertiesContentContext';

/**
 * @typedef {Object} PropertyContentProviderProps
 * @property {import('../../../../propTypes/PropertyContent').PropertyContent[]} value
 * @property {import('react').ReactNode} children
 */

/**
 * @param {PropertyContentProviderProps} props
 */
const PropertyContentProvider = ({ value, children }) => {
  const { searchQuery } = useSearchQuery();
  const { originCode } = searchQuery;

  const properties = useMemo(
    () =>
      value.filter((p) => {
        const { searchConfig } = p.destination;

        if (!originCode) {
          return true;
        }

        return searchConfig.originCodes.includes(originCode);
      }),
    [originCode, value],
  );

  return (
    <PropertiesContentContext.Provider value={properties}>
      {children}
    </PropertiesContentContext.Provider>
  );
};

PropertyContentProvider.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape(PropertyContent)).isRequired,
  children: PropTypes.node.isRequired,
};

export default PropertyContentProvider;
